export default __webpack_public_path__ + "static/assets/21fbcded3da99e037136959eb60472a6.png";